/* Presentation only: original Shopify products, variants and stock remain authoritative. */
(() => {
  let generation = 0;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  async function section(base, name, page) {
    const url = new URL(base); url.searchParams.delete('sedy_page');
    url.searchParams.set('section_id', name); url.searchParams.set('page', page);
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const res = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)});
        if (!res.ok) throw new Error('Section unavailable: ' + res.status);
        const doc = parse(await res.text());
        if (name === 'sedy-family-index' && !doc.querySelector('[data-sedy-family-index]')) throw new Error('Family index unavailable');
        return doc;
      } catch (error) {
        if (attempt === 2) throw error;
        await new Promise(resolve => setTimeout(resolve, 800 * (attempt + 1)));
      }
    }
  }
  function compactLocal() {
    const parents = new Set();
    document.querySelectorAll('product-card[data-sedy-family]:not([data-sedy-family=""])').forEach(card => {
      if (card.closest('#filter-results')) return;
      const li = card.closest('li'); if (li) parents.add(li.parentElement);
    });
    parents.forEach(parent => {
      const seen = new Set();
      [...parent.children].forEach(li => {
        const key = li.querySelector('product-card')?.dataset.sedyFamily;
        if (!key) return;
        li.hidden = seen.has(key); seen.add(key);
      });
    });
  }
  async function regroup(reset = false) {
    const token = ++generation;
    const root = document.querySelector('[data-sedy-group-grid]');
    if (!root) return;
    const grid = root.querySelector('ul'); if (!grid) return;
    const size = Number(root.dataset.sedyPageSize) || 24;
    const base = new URL(location.href);
    if (reset) {base.searchParams.delete('sedy_page'); base.searchParams.delete('page');}
    const nodes = new Map();
    const collect = doc => doc.querySelectorAll('[data-sedy-item-id]').forEach(li => nodes.set(li.dataset.sedyItemId, li));
    collect(root);
    try {
      const first = await section(base, 'sedy-family-index', 1);
      const el = first.querySelector('[data-sedy-family-index]');
      if (!el) throw new Error('Family index missing from section response');
      const index = JSON.parse(el.textContent);
      if (index.pages > 20) return; // fail safely to native pagination on unexpectedly large catalogs
      for (let p = 2; p <= index.pages; p++) {
        const doc = await section(base, 'sedy-family-index', p);
        index.items.push(...JSON.parse(doc.querySelector('[data-sedy-family-index]').textContent).items);
      }
      const seen = new Set(), unique = [];
      index.items.forEach((item, raw) => {
        const key = item.family.trim() || 'product:' + item.id;
        if (!seen.has(key)) {seen.add(key); unique.push({...item, raw});}
      });
      const pages = Math.max(1, Math.ceil(unique.length / size));
      const page = Math.min(pages, Math.max(1, Number(base.searchParams.get('sedy_page')) || 1));
      const selected = unique.slice((page - 1) * size, page * size);
      const required = new Set(selected.filter(x => !nodes.has(x.id)).map(x => Math.floor(x.raw / size) + 1));
      for (const p of required) collect(await section(base, root.dataset.sedySection, p));
      if (selected.some(x => !nodes.has(x.id))) throw new Error('Incomplete product page');
      if (token !== generation || !root.isConnected) return;
      const pagination = root.closest('custom-pagination') || root.querySelector('custom-pagination');
      if (pagination) {pagination.dataset.infiniteScroll = 'false'; pagination.dataset.pauseInfiniteScroll = 'true';}
      grid.replaceChildren(...selected.map(x => nodes.get(x.id).cloneNode(true)));
      // Keep filter and sort controls outside this results container untouched.
      root.querySelectorAll(':scope > nav, :scope > .sedy-group-count').forEach(n => n.remove());
      const count = document.createElement('p'); count.className = 'sedy-group-count';
      count.textContent = `${unique.length} products`;
      const bannerCount = document.querySelector('.collection-banner__count');
      if (bannerCount) bannerCount.textContent = `(${unique.length} products)`;
      root.append(count);
      if (pages > 1) {
        const nav = document.createElement('nav'); nav.className = 'sedy-group-pagination'; nav.setAttribute('aria-label', 'Product pages');
        for (let n = 1; n <= pages; n++) {
          const a = document.createElement('a'), url = new URL(base);
          url.searchParams.set('page', '1'); url.searchParams.set('sedy_page', n);
          a.href = url; a.textContent = n;
          if (n === page) a.setAttribute('aria-current', 'page');
          nav.append(a);
        }
        root.append(nav);
      }
      root.dataset.sedyGrouped = 'true'; root.dataset.sedyTotal = unique.length;
      document.dispatchEvent(new CustomEvent('sedy:groups-ready'));
    } catch (error) {console.warn('SEDY grouping: native product list retained.', error);}
  }
  function start() {compactLocal(); regroup();}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('on:facet-filters:updated', () => {compactLocal(); regroup(true);});
  let timer;
  new MutationObserver(() => {clearTimeout(timer); timer = setTimeout(compactLocal, 150);}).observe(document.documentElement, {childList:true, subtree:true});
})();
